import api from "./apiClient";

const API_URL = process.env.VUE_APP_API_BASE_URL + '/api/v2/';

export default {
  async tipsterPanel(payload) {
    const response = await api.post(API_URL + "tipster/panel", payload ?? {});
    return response.data;
  },

  async tipsterPanelAdmin(tipsterId, payload) {
    const response = await api.post(API_URL + `tipster/panel/${tipsterId}`, payload ?? {});
    return response.data;
  },

  async regenerarEnlacePedido(pedidoId, tipsterId = null) {
    const payload = { pedido_id: pedidoId };
    const url = tipsterId
      ? API_URL + `tipster/panel/${tipsterId}/pedidos/regenerar-enlace`
      : API_URL + "tipster/panel/pedidos/regenerar-enlace";
    const response = await api.post(url, payload);
    return response.data;
  },

  async exportarPedidosPanel(payload) {
    return await api.post(API_URL + "tipster/panel/pedidos/export", payload ?? {}, { responseType: "blob",
    });
  },

  async exportarPedidosPanelAdmin(tipsterId, payload) {
    return await api.post(API_URL + `tipster/panel/${tipsterId}/pedidos/export`, payload ?? {}, { responseType: "blob",
    });
  },

  async renovacionesActivas(params = {}) {
    const response = await api.get(API_URL + "tipster/panel/renovaciones-activas", { params });
    return response.data;
  },

  async renovacionesActivasAdmin(tipsterId, params = {}) {
    const response = await api.get(API_URL + `tipster/panel/${tipsterId}/renovaciones-activas`, { params });
    return response.data;
  },

  async ventasDetalle(payload) {
    const response = await api.post(API_URL + "tipster/panel/ventas-detalle", payload ?? {});
    return response.data;
  },

  async ventasDetalleAdmin(tipsterId, payload) {
    const response = await api.post(API_URL + `tipster/panel/${tipsterId}/ventas-detalle`, payload ?? {});
    return response.data;
  },

  async devolucionesDetalle(payload) {
    const response = await api.post(API_URL + "tipster/panel/devoluciones-detalle", payload ?? {});
    return response.data;
  },

  async devolucionesDetalleAdmin(tipsterId, payload) {
    const response = await api.post(API_URL + `tipster/panel/${tipsterId}/devoluciones-detalle`, payload ?? {});
    return response.data;
  },

  async clientePanel(payload) {
    const response = await api.post(API_URL + "cliente/dashboard", payload ?? {});
    return response.data;
  },

  async clientePanelAdmin(userId, payload) {
    const response = await api.post(API_URL + `cliente/dashboard/${userId}`, payload ?? {});
    return response.data;
  },

  async listaClientesAdmin() {
    const response = await api.post(API_URL + "listaClientesAdmin", null);
    return response.data;
  },

  async cancelarSuscripcion(suscripcionId) {
    const response = await api.post(API_URL + "cliente/cancelar-suscripcion", { suscripcion_id: suscripcionId });
    return response.data;
  },

  async iniciarReactivacion(suscripcionId) {
    const response = await api.post(API_URL + `cliente/reactivar-suscripcion/${suscripcionId}`, {});
    return response.data;
  },

  async confirmarReactivacion(suscripcionId, paymentIntentId) {
    const response = await api.post(API_URL + "cliente/confirmar-reactivacion", {
      suscripcion_id: suscripcionId,
      payment_intent_id: paymentIntentId,
    });
    return response.data;
  },

  async iniciarActualizarPago(suscripcionId) {
    const response = await api.post(API_URL + `cliente/actualizar-pago/${suscripcionId}`, {});
    return response.data;
  },

  async confirmarActualizarPago(suscripcionId, setupIntentId) {
    const response = await api.post(API_URL + "cliente/confirmar-actualizar-pago", {
      suscripcion_id: suscripcionId,
      setup_intent_id: setupIntentId,
    });
    return response.data;
  },

  async suscripcionesLista(params = {}) {
    const response = await api.get(API_URL + "tipster/panel/suscripciones", { params });
    return response.data;
  },

  async suscripcionesListaAdmin(tipsterId, params = {}) {
    const response = await api.get(API_URL + `tipster/panel/${tipsterId}/suscripciones`, { params });
    return response.data;
  },

  async publicistaPanel(payload) {
    const response = await api.post(API_URL + "publicista/panel", payload ?? {});
    return response.data;
  },
};
